export class NewProductItem {
    operationState="i";
    IsRemove :false;
    idProductItem:number;
    idProductManufacturer:number
    idVendor:number;
    productItemDescription:string;
    productItemGST:number;
    productItemMRP:number;
    productItemPrice:number;
    productItemPurchesPrice:number;
    productItemSaleFlag:number;
    productItemBarCode :string;      
    productItemSerialNo:string;
    vendorName:string;
    productManufacturerName:string;
    productName:string;
    productGST:number;
    productHSN:string;
    productWarrantyInYear='';
    productWarrantyInMonth='';

    

}